import routerOptions0 from "/home/jcwl/project/roncoo-education-web/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}